/**
 * Spreads initials tiles across a fixed set of tones so a long list of accounts or venues
 * doesn't read as one block of colour, the way Material's generated avatars do.
 *
 * The tone is derived from the name, so the same account keeps the same colour on every
 * render and across sessions — no state to store, and no reshuffling when the list is
 * filtered or re-sorted.
 *
 * Every tone in the palette clears WCAG AA (4.5:1) against white text; the values live in
 * `shared/components/default-avatar/default-avatar.component.scss`, keyed by the index this
 * returns.
 */
export const AVATAR_TONE_COUNT = 8;

export function avatarTone(name: string | null | undefined): number {
  const normalized = (name ?? '').trim().toLowerCase();

  if (!normalized) {
    return 0;
  }

  // FNV-1a, for a well-spread hash that stays stable across engines.
  let hash = 0x811c9dc5;
  for (let index = 0; index < normalized.length; index++) {
    hash ^= normalized.charCodeAt(index);
    hash = Math.imul(hash, 0x01000193);
  }

  return Math.abs(hash) % AVATAR_TONE_COUNT;
}
